
import Vue, { PropType } from 'vue';
import IconButton from '@/common/icon-button/IconButton.vue';
import { isFunction, get } from 'lodash';

interface HelpConfig {
    onClick: ()=>void
}

export default Vue.extend({
    components: {
        IconButton
    },

    props: {
        config: {
            type: Object as PropType<HelpConfig>,
            default: () => ({})
        },
        labels: {
            type: Object as PropType<Record<string, unknown>>,
            default: () => ({})
        },
        isLeft: {
            type: Boolean as PropType<boolean>,
            default: false
        }
    },

    computed: {
        onClick(): () => void {
            const handler = get(this, 'config.onClick', {});
            if (isFunction(handler)) {
                return handler;
            }
            return () => undefined;
        }
    }
});
